import * as Yup from 'yup';

const stepThreeSchema = Yup.object().shape({
    enabled: Yup.array().of(Yup.string()).min(1, 'Please select at least one test').required('Please select at least one test'),
    sat1600: Yup.object().shape({
        enabled: Yup.boolean(),
        readingAndWriting: Yup.mixed().when('enabled', {
            is: true,
            then: Yup.mixed().required('This field is required'),
        }),
        math: Yup.mixed().when('enabled', {
            is: true,
            then: Yup.mixed().required('This field is required'),
        }),
    }),
    sat2400: Yup.object().shape({
        enabled: Yup.boolean(),
        reading: Yup.mixed().when('enabled', {
            is: true,
            then: Yup.mixed().required('This field is required'),
        }),
        writing: Yup.mixed().when('enabled', {
            is: true,
            then: Yup.mixed().required('This field is required'),
        }),
        math: Yup.mixed().when('enabled', {
            is: true,
            then: Yup.mixed().required('This field is required'),
        }),
    }),
    act: Yup.object().shape({
        enabled: Yup.boolean(),
        score: Yup.mixed().when('enabled', {
            is: true,
            then: Yup.mixed().required('This field is required'),
        }),
    }),
    na: Yup.object().shape({
        enabled: Yup.boolean(),
        reason: Yup.string().when('enabled', {
            is: true,
            then: Yup.string().required('This field is required'),
        }),
    }),
    gmat: Yup.object().shape({
        enabled: Yup.boolean(),
        score: Yup.mixed().when('enabled', {
            is: true,
            then: Yup.mixed().required('This field is required'),
        }),
    }),
    lsat: Yup.object().shape({
        enabled: Yup.boolean(),
        score: Yup.mixed().when('enabled', {
            is: true,
            then: Yup.mixed().required('This field is required'),
        }),
    }),
    gre: Yup.object().shape({
        enabled: Yup.boolean(),
        analytical: Yup.mixed().when('enabled', {
            is: true,
            then: Yup.mixed().required('This field is required'),
        }),
        quantitative: Yup.mixed().when('enabled', {
            is: true,
            then: Yup.mixed().required('This field is required'),
        }),
        verbal: Yup.mixed().when('enabled', {
            is: true,
            then: Yup.mixed().required('This field is required'),
        }),
    }),
  }
);

export default stepThreeSchema;
